import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';
import Datepicker from 'react-tailwindcss-datepicker';
import InputSuggest from '../../../Inputs/InputSuggest';

function Geral({
    editarProposta,

    arrayLayout,
    layout,
    setLayout,
    textoIntro,
    setTextoIntro,
    textoDespedida,
    setTextoDespedida,
    arrayTextoDespedida,
    setOnChangeForm,
    prazoEntrega,
    setPrazoEntrega,
    localEntrega,
    setLocalEntrega,
    arrayLocalEntrega,
    validadeProposta,
    setValidadeProposta,
    setObservacoes,
    observacoes,

    setContactoAssinatura,
    contactoAssinatura,
    textosIntro,
    acrescimoIVA,
    setAcrescimoIVA,
    ecovalor,
    setEcovalor,
    ecolub,
    setEcolub,
    ecobat,
    setEcobat,
    arrayValidadeProposta,
    arrayPrazosEntrega,
}) {
    const {t} = useTranslation();
    const FORMATO_DATA = 'YYYY-MM-DD';

    return (
        <form className="mt-4">
            <div className="grid gap-6 mb-3 md:grid-cols-3">
                <div>
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('layout')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayLayout ? arrayLayout : ''}
                        value={layout}
                        onChange={e => {
                            setLayout(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
                <div>
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('textoIntroducao')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={textosIntro ? textosIntro : ''}
                        value={textoIntro}
                        onChange={e => {
                            setTextoIntro(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
                <div>
                    <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('textoDespedida')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayTextoDespedida ? arrayTextoDespedida : ''}
                        value={textoDespedida}
                        onChange={e => {
                            setTextoDespedida(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-3">
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('prazoEntrega')}
                    </label>

                    {/* <Datepicker
                        disabled={!editarProposta}
                        displayFormat={FORMATO_DATA}
                        useRange={false}
                        asSingle={true}
                        value={prazoEntrega}
                        onChange={newValue => {
                            setPrazoEntrega(newValue);
                            setOnChangeForm(true);
                        }}
                        inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            !editarProposta
                                ? 'bg-gray-50 dark:bg-gray-800'
                                : 'bg-white dark:bg-gray-900'
                        }`}
                    /> */}
                    {/* <input
                        type="text"
                        // defaultValue={prazoEntrega}
                        value={prazoEntrega}
                        className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                        } `}
                        onChange={e => {
                            setPrazoEntrega(e.target.value);

                            setOnChangeForm(true);
                        }}
                        required
                        disabled={!editarProposta}
                    /> */}
                    <InputSuggest
                        value={prazoEntrega}
                        onChange={value => {
                            setPrazoEntrega(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayPrazosEntrega}
                        disabled={!editarProposta}
                    />
                </div>

                <div>
                    <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('localEntrega')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayLocalEntrega}
                        value={localEntrega}
                        onChange={e => {
                            setLocalEntrega(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
                <div>
                    <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('validadeProposta')}
                    </label>
                    {/* 
                    <Datepicker
                        disabled={!editarProposta}
                        displayFormat={FORMATO_DATA}
                        useRange={false}
                        asSingle={true}
                        value={validadeProposta}
                        onChange={newValue => {
                            setValidadeProposta(newValue);
                            setOnChangeForm(true);
                        }}
                        inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                        }`}
                    /> */}
                    {/* 
                    <input
                        type="text"
                        // defaultValue={prazoEntrega}
                        value={validadeProposta}
                        className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                        } `}
                        onChange={e => {
                            setValidadeProposta(e.target.value);

                            setOnChangeForm(true);
                        }}
                        required
                        disabled={!editarProposta}
                    /> */}
                    <InputSuggest
                        value={validadeProposta}
                        onChange={value => {
                            setValidadeProposta(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayValidadeProposta}
                        disabled={!editarProposta}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('contactoAssinatura')}
                    </label>
                    <input
                        type="text"
                        // defaultValue={prazoEntrega}
                        value={contactoAssinatura}
                        className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                        } `}
                        onChange={e => {
                            setContactoAssinatura(e.target.value);
                            //   setValidacaoNome(false);
                            setOnChangeForm(true);
                        }}
                        required
                        disabled={!editarProposta}
                    />
                </div>
            </div>
            <div>
                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('observacoes')}
                </label>
                <textarea
                    disabled={!editarProposta}
                    id="message"
                    rows="1"
                    maxLength={250}
                    value={observacoes}
                    onChange={e => {
                        setOnChangeForm(true);
                        setObservacoes(e.target.value);
                        //   setValidacaoDesc(false);
                    }}
                    className={`block p-2.5 w-full text-sm text-gray-900  rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${
                        !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                    }`}
                    placeholder={t('escrevaObs')}></textarea>
            </div>
            <div className="grid gap-6 mt-3 mb-3 md:grid-cols-2">
                <div>
                    <span className="block mt-4 mb-2 text-sm font-medium text-gray-500 dark:text-white">{t('condicoesFornecimento')}</span>
                    <div className="mb-2">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={acrescimoIVA} onChange={() => setAcrescimoIVA(!acrescimoIVA)} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('condicoesFornecimento2')}</span>
                        </label>
                    </div>
                </div>

                <div className="flex-col mb-4">
                    <div className="mb-2">
                        <span className="block mt-4 mb-2 text-sm font-medium text-gray-500 dark:text-white">{t('condicoesFornecimento3')}</span>

                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={ecovalor} onChange={() => setEcovalor(!ecovalor)} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('condicoesFornecimento4')}</span>
                        </label>
                    </div>
                    <div className="mb-2">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={ecolub} onChange={() => setEcolub(!ecolub)} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('condicoesFornecimento5')}</span>
                        </label>
                    </div>
                    <div>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={ecobat} onChange={() => setEcobat(!ecobat)} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('condicoesFornecimento6')}</span>
                        </label>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default Geral;
